import { render, staticRenderFns } from "./RollingStockDetailRow.vue?vue&type=template&id=5b23778f&scoped=true"
import script from "./RollingStockDetailRow.vue?vue&type=script&lang=js"
export * from "./RollingStockDetailRow.vue?vue&type=script&lang=js"
import style0 from "./RollingStockDetailRow.vue?vue&type=style&index=0&id=5b23778f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b23778f",
  null
  
)

export default component.exports